var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewYear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new_year",
    "data-name": "new year",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.35 79.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3cb4d;}.cls-2{fill:#3975bb;}.cls-3{fill:#e11d3f;}.cls-4{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "newyear-hat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.76,32.8L45.58,100.45s26.79,17.91,57.71-5.09Z",
    transform: "translate(-43.45 -28.87)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.07 63.37 10.6 62.11 12.01 65.55 8.06 68.1 12.46 68.17 15.16 71.78 16.02 68.11 19.95 67.63 16.95 65.2 17.77 61.41 14.07 63.37"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.96 51.1 41.59 47.67 39.96 51.01 35.43 49.75 38.3 53.08 37.4 57.5 40.71 55.71 43.68 58.32 43.5 54.47 46.88 52.56 42.96 51.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.44 74.38 47.14 74.62 44.82 71.71 47.89 68.16 43.66 69.32 40.05 66.61 40.25 70.37 36.62 71.94 40.18 73.42 40.45 77.29 43.44 74.38"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "36.4 24.84 36.27 21.14 33.61 23.73 29.77 21.02 31.34 25.12 29.01 28.98 32.73 28.41 34.65 31.87 35.77 28.18 39.6 27.53 36.4 24.84"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.34 40.8 20.38 38.58 20.73 42.28 16.21 43.57 20.39 44.92 21.93 49.16 23.82 45.9 27.72 46.58 25.55 43.39 27.44 40 23.34 40.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.23,28.87l-24.78,72s28.19,20.44,61.35-5.88ZM46.34,99.59l22.51-65,32.73,60.17C71.5,116.43,46.34,99.59,46.34,99.59Z",
    transform: "translate(-43.45 -28.87)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYear);
export default __webpack_public_path__ + "static/media/new-year.39680c953c7a582f360ce2b6e50073e0.svg";
export { ForwardRef as ReactComponent };